import React, { useState, useEffect, useRef } from 'react';
import { styled } from '@mui/material/styles';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IconButton, Grid, Tooltip, Fab } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import routes from '../../constants/Routes';
import Checkbox from '@mui/material/Checkbox';
import '../../scss/statuses.scss';
import FormControlLabel from '@mui/material/FormControlLabel';
import CreateTwoToneIcon from '@mui/icons-material/CreateTwoTone';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import { MultiSelect } from 'primereact/multiselect';
import clsx from 'clsx';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';
import toDate from 'date-fns/toDate';
import parseISO from 'date-fns/parseISO';
import isValid from 'date-fns/isValid';
import ContentStatusDialogBox from './SubComponents/DialogBox/ContentStatusDialogBox';
import PaymentStatusDialogBox from './SubComponents/DialogBox/PaymentStatusDialogBox';
import moment from 'moment';
import { getCampaignDatesInArray } from 'jsonutils/campaign';
import { getMinMaxDatesParse } from 'util/date-utils';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { resetPopup, showPopup } from 'Stores/Slices/popUpSlice';
import { CampaignState, deleteCampaignById, getAllCampaignDetails, getCampaignDetailsById, resetCampaignState, updateCampaignMode } from 'Stores/Slices/campaignSlice';
import { RootState } from 'Stores/store';
import { useNavigate } from 'react-router-dom';
const PREFIX = 'CampaignList';

const classes = {
    fab: `${PREFIX}-fab`,
    absolute: `${PREFIX}-absolute`,
    fabIcon: `${PREFIX}-fabIcon`,
    textEllipsisEffect: `${PREFIX}-textEllipsisEffect`,
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.fab}`]: {
		margin: theme.spacing(2),
	},

    [`& .${classes.absolute}`]: {
		marginBottom:"10px"
	},

    [`& .${classes.fabIcon}`]: {
		color: theme.palette.common.white,
		backgroundColor: "#042630",
		'&:hover': {
			backgroundColor: "rgba(4, 38, 48, 0.8)",

		},
	},

    [`& .${classes.textEllipsisEffect}`]: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	}
}));
interface Props {
	role?: string;
}
const CampaignList = (props: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
	const [tableRows, setTableRows] = useState(10);
	const [page, setPage] = useState(0);
	const [loading, setLoading] = useState(false);
	const [first, setFirst] = useState(0);
	const dtRef = useRef<any>(null);

	const campaignStore: CampaignState = useAppSelector(
		(state: RootState) => state.campaign,
	);
	const { selectedId, list: campaignList, totalElements: totalRecords } = campaignStore;
	const popup = useAppSelector((state: RootState) => state.popup);
	const { confirmation } = popup;
	useEffect(() => {
		if (confirmation === 'agree') {
			dispatch(resetPopup());
			dispatch(deleteCampaignById(selectedId ? selectedId : 0));
		}
	}, [confirmation, dispatch, selectedId]);

	const [isFilterHidden, setIsFilterHidden] = useState(false);
	const [globalFilter] = useState('');
	useEffect(() => {
		dispatch(getAllCampaignDetails());
		dispatch(resetCampaignState());
	}, [dispatch]);

	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState(1);
	const [open, setOpen] = useState(false);
	const sortMap = new Map([
		['clientDetails', 'companyName'],
		['createdByUser', 'createdBy'],
		['updatedByUser', 'updatedBy'],
	]);
	const getSortRequestArray = (
		inputSortField: any = sortField,
		inputSortOrder: any = sortOrder,
	) => {
		const sortArray: any = [];
		if (inputSortField && inputSortField.length) {
			const object = {
				columnName: sortMap.get(inputSortField)
					? sortMap.get(inputSortField)
					: inputSortField,
				direction: inputSortOrder === -1 ? 'desc' : 'asc',
			};
			sortArray.push(object);
		}

		return sortArray;
	};

	const filterMap = new Map();
	const mapRef = useRef(filterMap);

	useEffect(() => {
		const filterNames = [
			'campaignName',
			'campaignCost',
			'campaignStatus',
			'companyName',
			'createdBy',
			'updatedBy',
		];

		filterNames.forEach((filterName) => {
			mapRef.current.set(filterName, '');
		});
	}, []);

	const getFilterRequestArray = () => {
		const requestFilter = [];
		for (const [key, value] of mapRef.current) {
			const requestFilterObject: any = {};
			requestFilterObject.columnName = key;
			requestFilterObject.value = value;
			requestFilterObject.operationType = 'MATCH';
			requestFilter.push(requestFilterObject);
		}

		return requestFilter;
	};
	const startDate = (rowData: any, column: any) => {
		const datesInISOArray: any = getCampaignDatesInArray(rowData);
		const minMax = getMinMaxDatesParse(datesInISOArray);
		return (
            (<Root>
                <Typography>{moment(minMax.min).format('DD-MM-YYYY')}</Typography>
            </Root>)
        );
	};
	const endDate = (rowData: any, column: any) => {
		const datesInISOArray: any = getCampaignDatesInArray(rowData);
		const minMax = getMinMaxDatesParse(datesInISOArray);
		return (
			<>
				<Typography>{moment(minMax.max).format('DD-MM-YYYY')}</Typography>
			</>
		);
	};
	const generateTextFilter = (filterName: any) => (
		<InputText
			onInput={(e: any) => {
				filterMap.set(filterName, e.target.value);
        dispatch(
					getAllCampaignDetails(
						page,
						tableRows,
						getFilterRequestArray(),
						getSortRequestArray(),
					),
				);
			}}
			className="p-column-filter"
		/>
	);

	// const CampaignStatus = ( rowData: any ) => {

	// 	const getStyle = (status:any) => {
	// 		return {
	// 			color: statusMap.get(status)
	// 		}
	// 	}
	// 	return (<>
	// 	  { rowData.campaignStatus ?
	// 		<Typography style={getStyle(rowData.campaignStatus)}> {rowData.campaignStatus.toUpperCase()} </Typography>
	// 		: <> </>
	// 	  }
	// 		</>
	// 	)
	// }
	const handleClose = () => {
		setOpen(false);
	};
	const transformStatusToCSSClass = (status: any) => {
		return status.replace(/\s/g, '').toLowerCase();
	};

	const adCount = (rowData: any, column: any) => (
		<>
			<Typography className="p-column-title">{column.header} :</Typography>
			<Typography>{rowData[column.field]}</Typography>
		</>
	);

	const createdByUsername = (rowData: any, column: any) => (
		<>
			<Typography className="p-column-title">Created by User:</Typography>
			<Typography>{rowData[column.field].username}</Typography>
		</>
	);

	const updatedbyUsername = (rowData: any, column: any) => (
		<>
			<Typography className="p-column-title">Updated by User:</Typography>
			{rowData[column.field] && rowData[column.field].username && (
				<Typography>{rowData[column.field].username}</Typography>
			)}
		</>
	);

	const CampaignStatus = (rowData: any) => {
		return (
			<>
				{rowData.campaignStatus ? (
					<>
						<Typography className="p-column-title">Status :</Typography>
						<span
							className={classNames(
								'campaign-status',
								'status-' +
								transformStatusToCSSClass(rowData.campaignStatus),
							)}>
							{rowData.campaignStatus}
						</span>
					</>
				) : (
					<> </>
				)}
			</>
		);
	};
	const Amount = (rowData: any, column: any) => {
		return <Typography> ₹ {rowData[column.field]} </Typography>;
	};
	const CampaignName = (rowData: any, column: any) => {
		return (
			<>
				{rowData[column.field] ? (
					<>
						<Typography className="p-column-title">
							Campaign Name :
						</Typography>
						<Typography align="left">
							{' '}
							{rowData[column.field].charAt(0).toUpperCase() +
								rowData[column.field].slice(1)}{' '}
						</Typography>
					</>
				) : (
					<></>
				)}
			</>
		);
	};

	const DateTemplate = (rowData: any, column: any) => {
		return (
			<>
				<Typography className="p-column-title">{column.header} :</Typography>
				{isValid(parseISO(rowData[column.field]))
					? toDate(parseISO(rowData[column.field])).toLocaleString()
					: ''}
			</>
		);
	};

	const ContentStatus = (rowData: any) => {
		return (
			<>
				{rowData.contentStatus ? (
					<>
						<Typography className="p-column-title">
							Content Status :
						</Typography>
						<span>
							<ContentStatusDialogBox
								open={open}
								onClose={handleClose}
								rowData={rowData}
							/>
						</span>
					</>
				) : (
					<> </>
				)}
			</>
		);
	};

	const PaymentStatus = (rowData: any) => {
		return (
			<>
				{rowData.paymentStatus ? (
					<>
						<Typography className="p-column-title">
							Payment Status :
						</Typography>
						<span>
							<PaymentStatusDialogBox
								open={open}
								onClose={handleClose}
								rowData={rowData}
							/>
						</span>
					</>
				) : (
					<> </>
				)}
			</>
		);
	};




	const [columns] = useState([
		{
			field: 'campaignName',
			header: 'Name',
			body: CampaignName,
			width: '10em',
			filterElement: generateTextFilter('campaignName'),
			filterPlaceHolderText: 'Search by Campaign Name',
		},
		{
			field: 'adCount',
			header: 'Ad Count',
			body: adCount,
			width: '20em',
		},
		{
			field: 'campaignCost',
			header: 'Total Budget',
			body: Amount,
			width: '10em',
			filterElement: generateTextFilter('campaignCost'),
			filterPlaceHolderText: 'Search by Cost',
		},
		{
			field: 'campaignStatus',
			header: 'Campaign Status',
			body: CampaignStatus,
			width: '10em',
			filterElement: generateTextFilter('campaignStatus'),
			filterPlaceHolderText: 'Search by Cost',
		},
		{
			field: 'createdByUser',
			header: 'Created By User',
			body: createdByUsername,
			filterElement: generateTextFilter('createdBy'),
			filterPlaceHolderText: 'Search by Campaign Status',
			width: '15em',
		},
		{
			field: 'createdOn',
			header: 'Created On',
			body: DateTemplate,
			width: '15em',
		},
		{
			field: 'updatedByUser',
			header: 'Updated By User',
			body: updatedbyUsername,
			filterElement: generateTextFilter('updatedBy'),
			filterPlaceHolderText: 'Search by Campaign Status',
			width: '15em',
		},
		{
			field: 'updatedOn',
			header: 'Updated On',
			body: DateTemplate,
			width: '15em',
		},
		{
			field: 'contentStatus',
			header: 'Content Status',
			body: ContentStatus,
			filterElement: generateTextFilter('contentStatus'),
			filterPlaceHolderText: 'Search by Campaign Status',
			width: '15em',
		},
		{
			field: 'paymentStatus',
			header: 'Payment Status',
			body: PaymentStatus,
			filterElement: generateTextFilter('paymentStatus'),
			filterPlaceHolderText: 'Search by Campaign Status',
			width: '15em',
		},
	]);
	const [selectedColumns, setselectedColumns] = useState<any>(columns);
	const onColumnToggle = (e: any) => {
		const selectedColumns = e.value;
		const orderedSelectedColumns: any = columns.filter((col: any) =>
			selectedColumns.some((sCol: any) => sCol.field === col.field),
		);
		setselectedColumns(orderedSelectedColumns);
	};

	const columnComponents = selectedColumns?.map((col: any) => {
		return (
			<Column
				key={col.field}
				field={col.field}
				body={col.body}
				header={col.header}
				sortable={true}
				filter={isFilterHidden}
				filterPlaceholder={col.filterPlaceHolderText}
				filterElement={col.filterElement}
				filterMatchMode="custom"
			/>
		);
	});
	const header = (
		<>
			<div>
				<span style={{ float: 'left' }}>
					<MultiSelect
						value={selectedColumns}
						placeholder='Select Column'
						options={columns}
						optionLabel="header"
						onChange={(e) => onColumnToggle(e)}
						style={{ width: '350px', border: 'none' }}
					/>
				</span>
				<div style={{ textAlign: 'right' }}>
					<FormControlLabel
						control={
							<Checkbox
								name="showFilters"
                style={{ color: '#042630'}}
								onChange={(e) => onFiltersShow(e.target.checked)}
							/>
						}
						label="Show Filters"
					/>
				</div>
			</div>
		</>
	);

	const openViewModal = (rowData: any) => {
		dispatch(updateCampaignMode(rowData.id, 'VIEW'));
		dispatch(getCampaignDetailsById(rowData.id));
		navigate(routes.VIEW_CAMPAIGN.path);
	};
	const openCreateClientModal = () => {
    navigate(routes.CREATE_CAMPAIGN.path);
	};

	const openDeleteModal = (rowData: any) => {
		dispatch(updateCampaignMode(rowData.id, 'DELETE'));
		dispatch(showPopup('Are you sure that you want to delete?'));
	};

	const openEditModal = (rowData: any) => {
		if (rowData.campaignStatus !== 'expired') {
			dispatch(updateCampaignMode(rowData.id, 'EDIT'));
			dispatch(getCampaignDetailsById(rowData.id));
			navigate(routes.EDIT_CAMPAIGN.path);
		}
	};

	const onFiltersShow = (isFilterShown: any) => {
		setIsFilterHidden(isFilterShown);
	};

	const actionTemplate = (rowData: any, column: any) => {
		return (
            <div>
				<IconButton
                    aria-label="view"
                    onClick={() => {
						openViewModal(rowData);
					}}
                    size="large">
					<VisibilityTwoToneIcon fontSize="small" />
				</IconButton>
				<IconButton
                    aria-label="edit"
                    onClick={() => {
						openEditModal(rowData);
					}}
                    size="large">
					<CreateTwoToneIcon fontSize="small" />
				</IconButton>

				<IconButton
                    aria-label="delete"
                    onClick={() => {
						openDeleteModal(rowData);
					}}
                    size="large">
					<DeleteIcon fontSize="small" />
				</IconButton>
			</div>
        );
	};

	const onPage = async (event: any) => {
		setLoading(true);
		try {
			const { first: _first, rows } = event;
      dispatch(
				getAllCampaignDetails(
					event.page,
					rows,
					getFilterRequestArray(),
					getSortRequestArray(),
				),
			);
			setPage(event.page);
			setFirst(_first);
			setTableRows(rows);
			setLoading(false);
		} catch (error) {
			console.error('Error:', error);
			setLoading(false);
		}
	};

	return <Root>
        <div style={{padding:"15px"}}>
            <Grid container justifyContent="space-between" >
                <Grid item>
                    {/* <InputText
          type="search"
          placeholder="Global Search"
          onInput={(e) => setGlobalFilter(e.currentTarget.value)}
          style={{ width: '500px', margin: '10px' }}
        /> */}
                </Grid>
                <Grid item>
                    <Tooltip title="Create Advertisement" aria-label="add">
                        <Fab
                            size="medium"
                            className={clsx(classes.absolute, classes.fabIcon)}
                            onClick={openCreateClientModal}>
                            <AddIcon fontSize="small" />
                        </Fab>
                    </Tooltip>
                </Grid>
            </Grid>
            <div className="datatable-responsive-demo">
                <div className="data">
                    <DataTable
                        className="p-datatable-customers p-datatable-responsive-demo"
                        resizableColumns
                        columnResizeMode="expand"
                        sortField={sortField}
                        sortOrder={sortOrder === 0
                            ? 0
                            : sortOrder === 1
                            ? 1
                            : sortOrder === -1
                            ? -1
                            : null}
                        reorderableColumns={true}
                        value={campaignList}
                        globalFilter={globalFilter}
                        emptyMessage="No records found"
                        header={header}
                        paginator={true}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink
      LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        rows={tableRows}
                        rowsPerPageOptions={[5, 10, 20]}
                        selectionMode="single"
                        lazy
                        first={first}
                        onSort={(e) => {
                            setSortField(e.sortField);
                            setSortOrder(e.sortOrder? e.sortOrder : 1);
                            dispatch(
                              getAllCampaignDetails(
                                  page,
                                  tableRows,
                                  getFilterRequestArray(),
                                  getSortRequestArray(e.sortField, e.sortOrder),
                              ),
                          );
                        }}
                        ref={dtRef}
                        onPage={onPage}
                        loading={loading}
                        totalRecords={totalRecords}>
                        {columnComponents}
                        <Column
                            body={startDate}
                            style={{ textAlign: 'center', width: '10em' }}
                            header="Start Date"
                            field=""
                            reorderable={false}
                            sortable={false}
                        />
                        <Column
                            body={endDate}
                            style={{ textAlign: 'center', width: '10em' }}
                            header="End Date"
                            field=""
                            reorderable={false}
                            sortable={false}
                        />
                        <Column
                            body={actionTemplate}
                            style={{ width: '15em', textAlign: 'center' }}
                            header="Actions"
                            field=""
                            reorderable={false}
                            sortable={false}
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    </Root>;
};

export default CampaignList;
